import React from 'react';
import { func, oneOf, string } from 'prop-types';
import classNames from 'classnames';
import { SampleImage } from '../../Sample/components/SampleImage';
import './tray-sample.scss';

export const TraySample = ({ channel, imageUrl, onClick }) => {

  const isMobile = channel === 'mobile';
  const traySampleClasses = classNames('tray-sample', {
    'tray-sample--small': isMobile
  });
  const backgroundCircleClasses = classNames('sample-overlay__white-background-circle', {
    'sample-overlay__white-background-circle--small': isMobile
  });
  const closeButtonClasses = classNames('sample-overlay__close-button-orange', {
    'sample-overlay__close-button-orange--small': isMobile
  });

  return (
    <div className={traySampleClasses}>
      <button
        type="button"
        className="tray-sample-close-button"
        onClick={onClick}
        data-testid="tray-sample-button"
      >
        <span className={backgroundCircleClasses} />
        <span className={closeButtonClasses} />
      </button>
      <SampleImage mini url={imageUrl} />
    </div>
  );
};

TraySample.displayName = 'TraySample';

TraySample.propTypes = {
  channel: oneOf(['desktop', 'mobile', 'tablet']),
  imageUrl: string.isRequired,
  onClick: func,
};

TraySample.defaultProps = {
  channel: 'desktop',
  onClick: null
};
